import styled from 'styled-components';
export const StyledProjectListItem = styled.div`
  .card_inner {
    .ant-card-body {
      display: flex;
      justify-content: space-between;
    }
    .card_image {
      min-width: 120px;
      height: auto;
      //max-height: 75px;
      object-fit: cover;
    }
    .ant-image {
      width: 100%;
    }
    .content_side {
      width: 100%;
      margin-left: 20px;
      .ant-typography {
        color: ${({ theme }) => theme.textColor09};
        margin-top: 0;
        font-size: ${({ theme }) => theme.p1Size};
        margin-bottom: 15px;
      }
      .status_side {
        display: flex;
        justify-content: space-between;
        .status {
          padding: 2px 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          border: 1px solid ${({ theme }) => theme.borderColor};
          font-weight: ${({ theme }) => theme.fontWeightBolder};
          font-size: ${({ theme }) => theme.p3Size} !important;

          &.supported {
            color: ${({ theme }) => theme.brand02};
            background-color: ${({ theme }) => theme.statusDarkGreenLight};
          }

          &.realized {
            color: ${({ theme }) => theme.statusRealizedColor};
            background-color: ${({ theme }) => theme.brand04Light};
          }
          &.being_implemented {
            color: ${({ theme }) => theme.brand05};
            background-color: ${({ theme }) => theme.brand05Light};
          }
          &.not_supported {
            color: ${({ theme }) => theme.statusUnsupportedColor};
            background-color: ${({ theme }) => theme.brand06Light};
          }

          &.voting_is_closed {
            color: ${({ theme }) => theme.statusBrown} !important;
            background-color: ${({ theme }) => theme.statusBrownLight} !important;
          }
        }

        .ant-btn-text {
          padding: 0 14px;
        }
      }
      .project_date {
        border-top: 1px solid ${({ theme }) => theme.border};
        margin-top: 20px;
        padding-top: 23px;
        display: flex;
        justify-content: space-between;
        .dates {
          font-size: ${({ theme }) => theme.p2Size};
          font-weight: ${({ theme }) => theme.fontWeightRegular};
          line-height: ${({ theme }) => theme.lineHeight5};
          color: ${({ theme }) => theme.gray06};
        }
        .voited {
          margin-left: auto;
          margin-bottom: 0;
        }
      }
    }
  }

  .ant-card {
    &:hover {
      border-color: ${({ theme }) => theme.brand02};
      cursor: pointer;
    }
  }

  .card-title {
    font-size: ${({ theme }) => theme.p1Size};
    font-weight: ${({ theme }) => theme.fontWeightBolder};
  }
`;
